/* global require */

import i18n from 'i18next';
import last from 'lodash/last';
import Logger from '../../Logger';

const i18nXHRBackend = require('i18next-xhr-backend');

const namespaces = ['alternativefuelVehicle', 'carpoolToWork', 'common', 'electricVehicle', 'energyStarCopiers', 'energyStarDesktops', 'energyStarFridge', 'energyStarPrinters', 'errors', 'food', 'footprint', 'forgotPassword', 'geo', 'getStarted', 'globalMenu', 'goOrganic', 'graphs', 'home', 'hybridVehicle', 'installPvPanels', 'installSolarHeating', 'leaders', 'lineDryClothing', 'login', 'logout', 'lowCarbonDiet', 'lowFlowFaucets', 'lowFlowShowerheads', 'lowFlowToilet', 'maintainMyVehicles', 'modals', 'moreEfficientVehicle', 'pageTitles', 'plantTrees', 'powerMgmtComp', 'practiceEcoDriving', 'printDoubleSided', 'account', 'purchaseGreenElectricity', 'purchaseHighEfficiencyCooling', 'purchaseHighEfficiencyHeating', 'rechargeableBatteries', 'reduceAirTravel', 'reduceCommWaste', 'reset', 'rideMyBike', 'settings', 'shopping', 'signUp', 'switchToCfl', 't12ToT8', 'takeAction', 'takePublicTransportation', 'tanklessWaterHeater', 'telecommuteToWork', 'thermostatSummer', 'thermostatWinter', 'travel', 'turnOffLights', 'units', 'waterEfficientLandscaping', 'routes', 'sidePage', 'auth'];


const loadLocales = async (url, options, callback, _data) => {
  try {
    const res = await window.fetch(url);
    const body = await res.text();
    if (res.ok) {
      const translations = JSON.parse(body);
      const language = url.match(/\/([\w_]+)\.json/)[1];
      callback(JSON.stringify({ [language]: translations }), { status: res.status });
    } else {
      callback(null, { status: res.status });
    }
  } catch (err) {
    Logger.error(err);
    callback(null, { status: 400 });
  }
};

const keySeparator = '=>';
const pluralSeparator = '->';
const contextSeparator = '->';

function i18nFactory(directory, provider, callback) {
  const BackendProvider = provider || i18nXHRBackend;

  const options = {
    fallbackLng: 'en',
    lng: 'en',

    // have a common namespace used around the full app
    ns: namespaces,
    defaultNS: 'common',
    fallbackNS: ['common'],
    nsSeparator: '//',
    keySeparator,
    pluralSeparator,
    contextSeparator,
    parseMissingKeyHandler: key => last(key.split(keySeparator)).split(pluralSeparator)[0],

    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    backend: {
      // path where resources get loaded from
      loadPath: '/assets/translations/{{lng}}.json?ns={{ns}}',

      // your backend server supports multiloading
      // /locales/resources.json?lng=de+en&ns=ns1+ns2
      allowMultiLoading: true,
      // allow cross domain requests
      crossDomain: true,

      ajax: loadLocales,

    },
  };

  return i18n
    .use(BackendProvider)
    .init(options, callback);
}


export default i18nFactory;
